import { render, staticRenderFns } from "./PhoneLogin.vue?vue&type=template&id=fd4cec32&scoped=true&"
import script from "./PhoneLogin.vue?vue&type=script&lang=js&"
export * from "./PhoneLogin.vue?vue&type=script&lang=js&"
import style0 from "./PhoneLogin.vue?vue&type=style&index=0&id=fd4cec32&lang=scss&scoped=true&"
import style1 from "./PhoneLogin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4cec32",
  null
  
)

export default component.exports